import { createSlice } from "@reduxjs/toolkit";

export const SelectedClient = createSlice({
  name: "client",
  initialState: {
    selectedClient: null,
  },
  reducers: {
    setSelectedClient: (state, action) => {
      state.selectedClient = action.payload;
    },
  },
});

export const { setSelectedClient } = SelectedClient.actions;

export default SelectedClient.reducer;
